import React, { forwardRef } from 'react';
import {
  useSubscriptions,
  useSubscriptionsDispatch,
} from '@features/subscriptions/context/subscription-context';
import type { DrawerRefMethods } from '@goodfynd/hooks';
import { useDrawerRef } from '@goodfynd/hooks';
import { Drawer, Text } from '@goodfynd/ui';

import { SuiteCheckout } from './SuiteCheckout';

import classes from './SubscriptionsCheckout.module.css';

export const SuiteCheckoutDrawer = forwardRef<
  DrawerRefMethods,
  Record<string, never>
>(function SuiteCheckoutDrawer(_, ref) {
  const { close, isOpen, open } = useDrawerRef({
    ref,
  });
  const { newSuite } = useSubscriptions();
  const { changeSuite } = useSubscriptionsDispatch();

  return (
    <>
      <Drawer
        className={classes['checkout-drawer']}
        header={<Text as="pageTitle">Checkout</Text>}
        headerClass={classes['checkout-drawer-header']}
        onOpen={() => open()}
        open={isOpen || !!newSuite}
        onClose={() => {
          close();
          changeSuite(undefined);
        }}
      >
        {(isOpen || !!newSuite) && <SuiteCheckout />}
      </Drawer>
    </>
  );
});
